import { render, staticRenderFns } from "./PostPdfVo.vue?vue&type=template&id=74bc72ae&scoped=true&"
import script from "./PostPdfVo.vue?vue&type=script&lang=js&"
export * from "./PostPdfVo.vue?vue&type=script&lang=js&"
import style0 from "./PostPdfVo.vue?vue&type=style&index=0&id=74bc72ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc72ae",
  null
  
)

export default component.exports